export const CURRENT_VIEW = "CURRENT_VIEW";
